import * as Types from '../../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCarForAppointmentMutationVariables = Types.Exact<{
  car: Types.CreateCarInput;
}>;


export type CreateCarForAppointmentMutation = { __typename?: 'Mutation', createCar: { __typename?: 'Car', id: string, vin?: string | null, make?: string | null, model?: string | null, year?: number | null, colour?: string | null, licensePlate?: string | null } };


export const CreateCarForAppointmentDocument = gql`
    mutation CreateCarForAppointment($car: CreateCarInput!) {
  createCar(car: $car) {
    id
    vin
    make
    model
    year
    colour
    licensePlate
  }
}
    `;
export type CreateCarForAppointmentMutationFn = Apollo.MutationFunction<CreateCarForAppointmentMutation, CreateCarForAppointmentMutationVariables>;

/**
 * __useCreateCarForAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateCarForAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarForAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarForAppointmentMutation, { data, loading, error }] = useCreateCarForAppointmentMutation({
 *   variables: {
 *      car: // value for 'car'
 *   },
 * });
 */
export function useCreateCarForAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarForAppointmentMutation, CreateCarForAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarForAppointmentMutation, CreateCarForAppointmentMutationVariables>(CreateCarForAppointmentDocument, options);
      }
export type CreateCarForAppointmentMutationHookResult = ReturnType<typeof useCreateCarForAppointmentMutation>;
export type CreateCarForAppointmentMutationResult = Apollo.MutationResult<CreateCarForAppointmentMutation>;
export type CreateCarForAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateCarForAppointmentMutation, CreateCarForAppointmentMutationVariables>;